/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { cardListStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsCardList";
import getColor from "@insite/mobius/utilities/getColor";
import { screen } from "@monsma/XDL/Helpers";
import Edit from "@monsma/XDL/Icons/Edit";
import { removeLinkStyle } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

cardListStyles.headerContainer = {
    gap: 20,
    css: css`
        padding-bottom: 20px;
    `,
};

cardListStyles.titleGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        align-items: center;
    `,
};

cardListStyles.sortByGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        justify-content: flex-end;
        ${screen("gt", "sm")} {
            > div {
                width: auto;
            }
        }
    `,
};

cardListStyles.titleText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
    `,
};

cardListStyles.sortBySelect = {
    labelPosition: "left",
    labelProps: sortSelectStyles.select?.labelProps,
    cssOverrides: sortSelectStyles.select?.cssOverrides,
    sizeVariant: sortSelectStyles.select?.sizeVariant,
};

cardListStyles.cardHeaderWrapper = {
    css: css`
        display: flex;
        flex: 1;
        align-items: center;
        > div {
            flex: 0 0 50px;
        }
        > h6 {
            display: flex;
            flex: 1 1 100%;
        }
    `,
};

cardListStyles.descriptionText = {
    variant: "h6",
    css: css`
        margin-left: 20px;
        margin-bottom: 0;
    `,
};

cardListStyles.cardInfoContainer = {
    gap: 10,
};

cardListStyles.leftColumnGridItem = {
    width: [12, 6, 4, 4, 4],
    css: css`
        flex-direction: column;
    `,
};

cardListStyles.nameOnCardLabelText = {
    variant: "h6",
    css: css`
        margin-bottom: 10px;
    `,
};

cardListStyles.nameOnCardText = {
    size: 13,
    lineHeight: "22px",
    css: css`
        margin-bottom: 20px;
    `,
};

cardListStyles.expirationLabelText = cardListStyles.nameOnCardLabelText;

cardListStyles.expirationText = {
    size: cardListStyles.nameOnCardText?.size,
    lineHeight: cardListStyles.nameOnCardText?.lineHeight,
};

cardListStyles.centerColumnGridItem = {
    width: [12, 6, 5, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

cardListStyles.billingAddressText = {
    size: cardListStyles.nameOnCardText?.size,
    lineHeight: cardListStyles.nameOnCardText?.lineHeight,
};

cardListStyles.rightColumnGridItem = {
    width: [12, 12, 3, 2, 2],
    css: css`
        flex-direction: column;
    `,
};

cardListStyles.linksContainer = {
    gap: 30,
};

cardListStyles.useAsDefaultButton = {
    variant: "primary",
    sizeVariant: "small",
};

cardListStyles.editLink = {
    icon: {
        iconProps: {
            src: Edit,
            color: "common.ui3",
            size: 14,
            css: css`
                margin-right: 5px;
            `,
        },
    },
};

cardListStyles.deleteLink = {
    ...removeLinkStyle,
    css: css`
        ${removeLinkStyle?.css}
        margin-bottom: 10px;
        ${screen("lte", "sm")} {
            margin-bottom: 0;
        }
    `,
};

cardListStyles.useAsDefaultGridItem = {
    width: [12, 4, 12, 12, 12],
    css: css`
        justify-content: center;
    `,
};

cardListStyles.editLinkGridItem = {
    width: [6, 4, 12, 12, 12],
    css: css`
        justify-content: center;
        align-items: center;
    `,
};

cardListStyles.deleteLinkGridItem = {
    width: [6, 4, 12, 12, 12],
    css: css`
        justify-content: center;
        align-items: center;
    `,
};
